export default __webpack_public_path__ + "static/media/G4KUbryx.bc75716f.jpeg";